import { createContext, useState } from "react";

import { useDispatch } from "react-redux";
import { activeQuotePageMounted } from "~/features/cart/activeQuote/redux/actions";
import Spinner from "~/common/components/Spinner/Spinner";
import ActiveQuoteEdit from "~/features/cart/activeQuote/components/ActiveQuoteEdit/ActiveQuoteEdit";
import { Mode } from "~/features/cart/cart/models/QuoteData";
import ActiveQuoteReview from "~/features/cart/activeQuote/components/ActiveQuoteReview/ActiveQuoteReview";
import { useTranslation } from "react-i18next";
import { useOnMount } from "~/common/hooks/useOnMount";
import { LinkButton } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { useActiveQuoteViewModel } from "~/features/cart/activeQuote/hooks/useActiveQuoteViewModel";

import classes from "~/features/cart/activeQuote/components/ActiveQuotePage/ActiveQuotePage.module.less";
import { PageTitle } from "~/common/components/PageTitle/v2/PageTitle";

type SetModeFunc = (mode: Mode) => void;
export const ActiveQuotePageModeContext = createContext<SetModeFunc>(() => {
  throw Error("Not supported");
});

const ActiveQuoteRootPage = () => {
  const { t } = useTranslation();
  const [pageMode, setPageMode] = useState<Mode>(Mode.EDIT);
  const dispatch = useDispatch();
  const viewModel = useActiveQuoteViewModel();

  useOnMount(() => {
    dispatch(activeQuotePageMounted());
  });

  if (viewModel.isLoading) {
    return <Spinner />;
  }

  const accNo = viewModel.accountNumber;
  const context = !accNo ? "noAccNo" : undefined;

  const editButton = pageMode === Mode.REVIEW && (
    <LinkButton
      onClick={() => setPageMode(Mode.EDIT)}
      iconBefore={<Icon type={IconType.Pencil} />}
      className={classes.editButton}
    >
      {t("activeQuotePage.backToQuote")}
    </LinkButton>
  );

  return (
    <ActiveQuotePageModeContext.Provider value={setPageMode}>
      <div className={classes.titleContainer}>
        <PageTitle className={classes.title}>{t("activeQuotePage.title", { context, accNo })}</PageTitle>
        {editButton}
      </div>

      {pageMode === Mode.EDIT && <ActiveQuoteEdit viewModel={viewModel} />}
      {pageMode === Mode.REVIEW && <ActiveQuoteReview viewModel={viewModel} />}
    </ActiveQuotePageModeContext.Provider>
  );
};

export default ActiveQuoteRootPage;
